// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2HJrM","selected":"Chip_selected__1_opY"};